import * as React from 'react'

function SvgExpand(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 30 30" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.5 2a1.5 1.5 0 000 3h2.379l-4.94 4.94a1.5 1.5 0 002.122 2.12L25 7.122V9.5a1.5 1.5 0 003 0v-6A1.496 1.496 0 0026.5 2h-6zm6 17a1.5 1.5 0 00-1.5 1.5v2.379l-4.94-4.94a1.5 1.5 0 00-2.12 2.122L22.878 25H20.5a1.5 1.5 0 000 3h6a1.495 1.495 0 001.384-.922c.075-.178.116-.373.116-.578v-6a1.5 1.5 0 00-1.5-1.5zm-17 9h-6A1.496 1.496 0 012 26.5v-6a1.5 1.5 0 013 0v2.379l4.94-4.94a1.5 1.5 0 012.12 2.122L7.122 25H9.5a1.5 1.5 0 010 3zM2 9.5a1.5 1.5 0 003 0V7.121l4.94 4.94a1.5 1.5 0 002.12-2.122L7.122 5H9.5a1.5 1.5 0 000-3h-6a1.495 1.495 0 00-1.385.923A1.495 1.495 0 002 3.5v6z"
        fill="currentColor"
      />
    </svg>
  )
}

export default SvgExpand
